// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2AiKz","checkboxCol":"Table_checkboxCol__2vu0s","emailCol":"Table_emailCol__3iw7S","actionCol":"Table_actionCol__2Yvmi"};